// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostDetail_container__ffW6Y {
  max-width: 600px;
  margin: 40px auto;
  padding: 32px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
}
.PostDetail_backButton__NZGRJ {
  background: none;
  border: none;
  color: #1976d2;
  font-size: 1em;
  cursor: pointer;
  margin-bottom: 16px;
}
.PostDetail_imageArea__79m7p {
  display: flex;
  gap: 12px;
  margin: 16px 0;
}
.PostDetail_image__D8pLz {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #ccc;
}
.PostDetail_description__Fc2h9 {
  margin-top: 16px;
  font-size: 1.1em;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Post/PostDetail.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".container {\r\n  max-width: 600px;\r\n  margin: 40px auto;\r\n  padding: 32px 16px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 12px rgba(0,0,0,0.10);\r\n}\r\n.backButton {\r\n  background: none;\r\n  border: none;\r\n  color: #1976d2;\r\n  font-size: 1em;\r\n  cursor: pointer;\r\n  margin-bottom: 16px;\r\n}\r\n.imageArea {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin: 16px 0;\r\n}\r\n.image {\r\n  width: 120px;\r\n  height: 120px;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n  border: 1px solid #ccc;\r\n}\r\n.description {\r\n  margin-top: 16px;\r\n  font-size: 1.1em;\r\n  color: #333;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PostDetail_container__ffW6Y`,
	"backButton": `PostDetail_backButton__NZGRJ`,
	"imageArea": `PostDetail_imageArea__79m7p`,
	"image": `PostDetail_image__D8pLz`,
	"description": `PostDetail_description__Fc2h9`
};
export default ___CSS_LOADER_EXPORT___;
